import React, { useEffect, useState } from 'react';
import { API_BASE } from '../utils/apiUtils';

export default function TasksPage() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);

  const load = async () => {
    setLoading(true);
    try {
      const res = await fetch(`${API_BASE}/tasks/list`, { credentials: 'include' });
      const data = await res.json();
      setRows(Array.isArray(data) ? data : []);
    } catch (e) {
      setRows([]);
    } finally { setLoading(false); }
  };

  useEffect(() => { load(); }, []);

  const exportCsv = async () => {
    try {
      const res = await fetch(`${API_BASE}/tasks/export.csv`, { credentials: 'include' });
      const blob = await res.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'tasks.csv';
      a.click();
      window.URL.revokeObjectURL(url);
    } catch (e) {
      console.error('Export failed:', e);
    }
  };

  const viewReport = async () => {
    try {
      const res = await fetch(`${API_BASE}/tasks/report`, { credentials: 'include' });
      const data = await res.json();
      
      // Simple HTML report
      const html = `
        <!DOCTYPE html>
        <html>
        <head><title>Tasks Report</title></head>
        <body style="font-family: Arial; padding: 20px;">
          <h1>Tasks Report</h1>
          <p>Generated: ${data.generatedAt}</p>
          
          <h2>Summary</h2>
          <div style="display: flex; gap: 20px; margin-bottom: 20px;">
            <div style="background: #f0f0f0; padding: 10px; border-radius: 5px;">
              <strong>Total Tasks:</strong> ${data.kpis.total}
            </div>
            <div style="background: #e8f5e8; padding: 10px; border-radius: 5px;">
              <strong>Completed:</strong> ${data.kpis.completed}
            </div>
            <div style="background: #ffe8e8; padding: 10px; border-radius: 5px;">
              <strong>Overdue:</strong> ${data.kpis.overdue}
            </div>
            <div style="background: #fff3cd; padding: 10px; border-radius: 5px;">
              <strong>High Priority:</strong> ${data.kpis.highPriority}
            </div>
          </div>
          
          <h2>Recent Completed Tasks (Last 30 Days)</h2>
          <table style="width: 100%; border-collapse: collapse; border: 1px solid #ddd;">
            <thead>
              <tr style="background: #f5f5f5;">
                <th style="border: 1px solid #ddd; padding: 8px;">Task</th>
                <th style="border: 1px solid #ddd; padding: 8px;">Due Date</th>
                <th style="border: 1px solid #ddd; padding: 8px;">Priority</th>
              </tr>
            </thead>
            <tbody>
              ${data.recentCompleted.map(t => `
                <tr>
                  <td style="border: 1px solid #ddd; padding: 8px;">${t.task}</td>
                  <td style="border: 1px solid #ddd; padding: 8px;">${t.due || ''}</td>
                  <td style="border: 1px solid #ddd; padding: 8px;">${t.priority || ''}</td>
                </tr>
              `).join('')}
            </tbody>
          </table>
        </body>
        </html>
      `;
      
      const newWindow = window.open('', '_blank');
      newWindow.document.write(html);
      newWindow.document.close();
    } catch (e) {
      console.error('Report failed:', e);
    }
  };

  return (
    <div style={{ padding: 16 }}>
      <h2>Tasks (from Excel uploads)</h2>
      <div style={{ marginBottom: 8 }}>
        <button onClick={load} disabled={loading}>{loading ? 'Loading...' : 'Refresh'}</button>
        <button style={{ marginLeft: 8 }} onClick={exportCsv}>Export CSV</button>
        <button style={{ marginLeft: 8 }} onClick={viewReport}>View Report</button>
      </div>
      <div style={{ overflowX: 'auto' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr>
              <th style={{ border: '1px solid #ddd', padding: 8 }}>Task</th>
              <th style={{ border: '1px solid #ddd', padding: 8 }}>Due</th>
              <th style={{ border: '1px solid #ddd', padding: 8 }}>Priority</th>
              <th style={{ border: '1px solid #ddd', padding: 8 }}>Status</th>
              <th style={{ border: '1px solid #ddd', padding: 8 }}>Source</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r, i) => (
              <tr key={i}>
                <td style={{ border: '1px solid #ddd', padding: 8 }}>{r.task}</td>
                <td style={{ border: '1px solid #ddd', padding: 8 }}>{r.due || ''}</td>
                <td style={{ border: '1px solid #ddd', padding: 8 }}>{r.priority}</td>
                <td style={{ border: '1px solid #ddd', padding: 8 }}>{r.status}</td>
                <td style={{ border: '1px solid #ddd', padding: 8 }}>{r.sourceFile} / {r.sheet}#{r.row}</td>
              </tr>
            ))}
            {!rows.length && (
              <tr><td colSpan={5} style={{ padding: 16, textAlign: 'center' }}>No tasks found</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}


